import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue/dist/bootstrap-vue.esm'; // ES Module, see https://bootstrap-vue.github.io/docs/setup#build-variants
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
export default {
  name: 'Bootstrap',
  bootstrap: function bootstrap() {
    Vue.use(BootstrapVue);
  }
};